$(".slider-style2").owlCarousel({
    loop:false,
    margin:10,
    nav:false,
    responsive:{
        0:{
            items:1
        },
        768:{
            items:2
        }
    }
});

var changeSlide = 4; // mobile -1, desktop + 1
// Resize and refresh page. slider-two slideBy bug remove
var slide = changeSlide;
          if ($(window).width() < 600) {
             var slide = changeSlide;
              slide--;
          }
          else if ($(window).width() > 999) {
             var slide = changeSlide;
              slide++;
          }
          else{
           var slide = changeSlide;
          }

    if($(".one").hasClass("realisations-slider")) {
        $(".one").owlCarousel({
            nav: true,
            items: 2,
            margin:10,
            responsive:{
                0:{
                    items:1
                },
                768:{
                    items:2
                }
            }
        });
    } else {
        $(".one").owlCarousel({
            lazyLoad: true,
            nav: true,
            items: 1,
        });
    }

      $('.two').owlCarousel({
          lazyLoad: true,
          nav: true,
          margin: 15,
          responsive: {
              0: {
                  items: changeSlide - 1,
                  slideBy: changeSlide - 1
              },
              600: {
                  items: changeSlide,
                  slideBy: changeSlide
              },
              1000: {
                  items: changeSlide + 1,
                  slideBy: changeSlide + 1
              }
          }
      });
      var owl = $('.one');
      owl.owlCarousel();
      owl.on('translated.owl.carousel', function(event) {
          $(".right").removeClass("nonr");
          $(".left").removeClass("nonl");
          if ($('.one .owl-next').is(".disabled")) {
              $(".slider .right").addClass("nonr");
          }
          if ($('.one .owl-prev').is(".disabled")) {
              $(".slider .left").addClass("nonl");
          }
          $('.slider-two .item').removeClass("active");
          var c = $(".slider .owl-item.active").index();
          $('.slider-two .item').eq(c).addClass("active");
          //var d = Math.ceil((c + 1) / (slide)) - 1;
          //$(".slider-two .owl-dots .owl-dot").eq(d).trigger('click');
      })
      $('.slider .right').click(function() {
          $(".slider .owl-next").trigger('click');
      });
      $('.slider .left').click(function() {
          $(".slider .owl-prev").trigger('click');
      });
      var owl2 = $('.two');
      owl2.owlCarousel();
      owl2.on('translated.owl.carousel', function(event) {
          $(".right-t").removeClass("nonr-t");
          $(".left-t").removeClass("nonl-t");
          if ($('.two .owl-next').is(".disabled")) {
              $(".slider-two .right-t").addClass("nonr-t");
          }
          if ($('.two .owl-prev').is(".disabled")) {
              $(".slider-two .left-t").addClass("nonl-t");
          }
      })
      $('.slider-two .right-t').click(function() {
          $(".slider-two .owl-next").trigger('click');
      });
      $('.slider-two .left-t').click(function() {
          $(".slider-two .owl-prev").trigger('click');
      });
      
    $(".slider-two .item").mousedown(function(e) {
        /*e.preventDefault();*/
        previousX = e.clientX;
        previousY = e.clientY;
    });
    
    $(".slider-two .item").mouseup(function(e) {
        if(previousX === e.clientX && previousY === e.clientY) {
            var b = $(".item").index(this);
            if($(".one").hasClass("realisations-slider") && $(document).width() >= 768) {
                b = Math.floor(b/2);
            }
            $(".slider .owl-dots .owl-dot").eq(b).trigger('click');
            $(".slider-two .item").removeClass("active");
            $(this).addClass("active");
        } else {
            previousX = e.clientX;
            previousY = e.clientY;
        }
    });

refreshSlide();

$( ".one" ).hover(
    function() {
        //if($(".picture-slider-medium").is(":visible") && $(document).width() >= 768) {
        if($(".picture img").hasClass("picture-slider-medium") && !$(".minimize").hasClass("minimize-display") && $(document).width() >= 768) {
          $(".minimize").toggleClass("minimize-display");
      }
    }, function() {
        if($(".picture img").hasClass("picture-slider-medium") && $(".minimize").hasClass("minimize-display") && $(document).width() >= 768) {
            $(".minimize").toggleClass("minimize-display");
        }
    }
);

$( "section .all .slider .left, section .all .slider .right" ).hover(function() {
    if($(".picture img").hasClass("picture-slider-medium") && $(document).width() >= 768 && !$(".minimize").hasClass("minimize-display")) {
        $(".minimize").toggleClass("minimize-display");
    }
    }, function() {
    if($(".picture img").hasClass("picture-slider-medium") && $(document).width() >= 768 && $(".minimize").hasClass("minimize-display")) {
    $(".minimize").toggleClass("minimize-display");
        }
    }
);

var waitForFinalEvent = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();

$(window).resize(function () {  
    waitForFinalEvent(function(){
        refreshSlide();
    }, 500, "some unique string");
});

var previousX, previousY;
var mousedown = false;

$(".picture img, .picture div").mousedown(function(e) {
    previousX = e.clientX;
    previousY = e.clientY;
    mousedown = true;
});

$(".picture img").mousemove(function(e) {
    if(mousedown) {
        $(this).css("cursor","grabbing");
    }
});

$(".slider-two .item").mousedown(function(e) {
    mousedown = true;
});

$(".slider-two .item").mousemove(function(e) {
    if(mousedown) {
        $(this).css("cursor","grabbing");
    }
});

$(".slider, .slider-two").mouseup(function(e) {
    mousedown = false;
    //$(".picture img").css("cursor","pointer");
    $(".picture-slider-small").css("cursor","pointer");
    $(".picture-slider-medium").css("cursor","grab");
    $(".slider-two .item").css("cursor","pointer");
});

/*$(".full-picture-background").click(function() {
    $(".full-picture").attr("src", "");
    $(".full-picture-background").hide();
});

$(".slider, .slider-two").keyup(function(e) {
    if(e.keyCode === 27) {
        $(".full-picture").attr("src", "");
        $(".full-picture-background").hide();
    }
});*/
    
$(".picture img, .picture div").mouseup(function(e) {
    if(previousX === e.clientX && previousY === e.clientY) {
        if($(".picture img").hasClass("picture-slider-small") && $(document).width() >= 768) {
            //$(".picture-slider-small").hide();
            //$(".picture-slider-medium").show();
            $(".picture img").removeClass("picture-slider-small");
            $(".picture img").addClass("picture-slider-medium");
            $(".picture img").each( function() {
                if($(this).attr("src")) {
                    $(this).attr("src",$(this).attr("src").replace("/img/slider_small","/img/slider_medium"));
                } else if($(this).attr("data-src")) {
                    $(this).attr("data-src",$(this).attr("data-src").replace("/img/slider_small","/img/slider_medium"));
                }
            });
            $(".property-slider").unwrap();
            $(".property-slider").wrap("<div class=\"col-md-12\">");
            $(".property-under-slider").wrap("<div class=\"col-md-6\">");
            $(".one").trigger('refresh.owl.carousel');
            $(".two").trigger('refresh.owl.carousel');
            refreshSlide();
            $(".minimize").toggleClass("minimize-display");
        } /*else {
            var imgUrl = $(this).parent().data('rel');
            $(".full-picture").attr("src",imgUrl);
            $(".full-picture-background").css("display","block");
        }*/
    } else {
        previousX = e.clientX;
        previousY = e.clientY;
    }
    mousedown = false;
    //$(".picture img").css("cursor","pointer");
    $(".picture-slider-small").css("cursor","pointer");
    $(".picture-slider-medium").css("cursor","grab");
    $(".slider-two .item").css("cursor","pointer");
});

$("section .all .slider .minimize").click(function(e) {
    //$(".picture-slider-medium").hide();
    //$(".picture-slider-small").show();
    $(".picture img").removeClass("picture-slider-medium");
    $(".picture img").addClass("picture-slider-small");
    $(".picture img").each( function() {
        if($(this).attr("src")) {
            $(this).attr("src",$(this).attr("src").replace("/img/slider_medium","/img/slider_small"));
        } else if($(this).attr("data-src")) {
            $(this).attr("data-src",$(this).attr("data-src").replace("/img/slider_medium","/img/slider_small"));
        }
    });
    $(".property-slider").unwrap();
    $(".property-under-slider").unwrap();
    $(".property-slider,.property-under-slider").wrapAll("<div class=\"col-md-6\">");
    $(".one").trigger('refresh.owl.carousel');
    $(".two").trigger('refresh.owl.carousel');
    refreshSlide();
    $(".minimize").removeClass("minimize-display");
});

function refreshSlide() {
    if($('section .all .slider').length) {
        var prop = $('section .all .slider').attr('class').match('prop-[0-9]*');
        if(prop === null) {
            prop = 0.62;
        } else {
            prop = "0." + prop[0].substring(5);
        }
        $('section .all .slider .owl-item img').height($('section .all .slider .owl-item').width()*prop);
        $('section .all .slider .left').css('top',($('section .all .slider .owl-item').height()/2)-32);
        $('section .all .slider .right').css('top',($('section .all .slider .owl-item').height()/2)-32);
    } else if($('.slider-style2').length) {
        var prop = $('.slider-style2').attr('class').match('prop-[0-9]*');
        if(prop === null) {
            prop = 0.62;
        } else {
            prop = "0." + prop[0].substring(5);
        }
        $('.slider-style2 img').height($('.slider-style2 .item').width()*prop);
    }
}